import { createSelector } from '@reduxjs/toolkit';
import { selectDiscountPromoSearchTypeValue } from './selectDiscountPromoSearchTypeValue';
import { selectDiscountPromoSearchTypeOptions } from './selectDiscountPromoSearchTypeOptions';

export const selectDiscountPromoSearchTypeFilter = createSelector(
  [selectDiscountPromoSearchTypeValue, selectDiscountPromoSearchTypeOptions],
  (value, options) => ({
    label: 'Скидки и акции',
    value,
    options,
  }),
);
